import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    ids: string[];
}>;

export const DispatchToggleSelectedRoles: HandlerType = props => {
    props.dispatch({
        type: "Custom/SecurityRoles/ToggleSelectedRoles",
        ids: props.parameter.ids,
    });
};

export const chain = [DispatchToggleSelectedRoles];

const selectRoles = createHandlerChainRunner(chain, "selectRoles");
export default selectRoles;
